export default function SymbolQty({ symbolQty }) {
  return (
    <div
      className={`grid grid-cols-${symbolQty.type === "nse" ||
          symbolQty.type === "nse_cash" ||
          symbolQty.type === "us_stock" ||
          symbolQty.type === "sgx" ||
          symbolQty.type === "index"
          ? "3"
          : 4
        } text-xs font-semibold text-[var(--text)] py-2 `}
    >
      {symbolQty.type === "nse" ||
        symbolQty.type === "nse_cash" ||
        symbolQty.type === "us_stock" ||
        symbolQty.type === "sgx" ||
        symbolQty.type === "index" ? (
        <div className="flex flex-col items-center">
          <span className="text-[11px] text-[var(--text)]">MIN-QTY</span>
          <span className="font-semibold">{symbolQty.min_qty}</span>
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <span className="text-[11px] text-[var(--text)]">LOT-SIZE</span>
          <span className="font-semibold">{symbolQty.lot_size}</span>
        </div>
      )}
      {symbolQty.type === "mcx" ||
        symbolQty.type === "fo" ||
        symbolQty.type === "comex_future" ||
        symbolQty.type === "crypto_future" ||
        symbolQty.type === "forex_future" ||
        symbolQty.type === "dgcx" ? (
        <div className="flex flex-col items-center">
          <span className="text-[11px] text-[var(--text)]">MIN LOT</span>
          <span className="font-semibold">
            {parseFloat(symbolQty.min_qty / symbolQty.lot_size).toFixed(2)}
          </span>
        </div>
      ) : null}
      {symbolQty.type === "nse" ||
        symbolQty.type === "nse_cash" ||
        symbolQty.type === "us_stock" ||
        symbolQty.type === "sgx" ||
        symbolQty.type === "index" ? (
        <div className="flex flex-col items-center">
          <span className="text-[11px] text-[var(--text)]">QTY-ORDER</span>
          <span className="font-semibold">{symbolQty.qty_per_order}</span>
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <span className="text-[11px] text-[var(--text)]">LOT-ORDER</span>
          <span className="font-semibold">
            {parseFloat(symbolQty.qty_per_order / symbolQty.lot_size).toFixed(
              2
            )}
          </span>
        </div>
      )}
      {symbolQty.type === "nse" ||
        symbolQty.type === "nse_cash" ||
        symbolQty.type === "us_stock" ||
        symbolQty.type === "sgx" ||
        symbolQty.type === "index" ? (
        <div className="flex flex-col items-center">
          <span className="text-[11px] text-[var(--text)]">MAX-QTY</span>
          <span className="font-semibold">{symbolQty.total_quantity}</span>
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <span className="text-[11px] text-[var(--text)]">MAX-LOT</span>
          <span className="font-semibold">
            {parseFloat(symbolQty.total_quantity / symbolQty.lot_size).toFixed(
              2
            )}
          </span>
        </div>
      )}
    </div>
  );
}
